// extracted by extract-css-chunks-webpack-plugin
module.exports = {"appointmentContainer":"QleWm","appointmentErrorCard":"_0WgUC"};